import React, {useState, useEffect} from 'react';

import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useDispatch, useSelector } from 'react-redux';

import { saveTimezone } from '../store/resources';

export default function SetTimezone() {
  const dispatch = useDispatch();
  const timezones = useSelector(state => state.timezones);
  const account_timezone = useSelector(state => state.account.timezone);
  const [timezone, setTZ] = useState('');

  useEffect(() => {
    setTZ(account_timezone || '');
  }, [account_timezone]);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(saveTimezone(timezone))
    .then(response => {
      if (response.status === "success") {
        window.alert("Success!");
      } else {
        window.alert(response.error);
      }
    });
  };

  return (
    <>
    <div className="col-12">
      <h1 className="text-center">Set Timezone</h1>
      <p>This will set the timezone for times shown in your Opened Report.</p>
    </div>
    <Form id="signup" className="row d-flex justify-content-center mx-3" onSubmit={handleSubmit}>
      <div className="col-12 col-md-6 mx-auto bg-white shadow rounded py-3 m-3 m-sm-0">
        <Form.Group className="col-12">
          <Form.Label>Timezone</Form.Label>
          <Form.Select onChange={(e) => setTZ(e.target.value)} value={timezone}>
            {timezones.map(tz => (
              <option key={tz} value={tz}>{tz}</option>
            ))}
          </Form.Select>
        </Form.Group>
        <div className="col-12">
          <Button type="submit" variant="danger btn-lg w-100 text-uppercase">Submit</Button>
        </div>
      </div>
    </Form>
    </>
  );
}
